import { Form, Input, ModalProps, Upload } from 'antd';
import { RcFile } from 'antd/lib/upload';
import React, { ReactNode, useEffect } from 'react';
import { FC, useState } from 'react';
import { IPOMessage, IPOInput, IPOModal, IPOIcons, IPOTag } from '../../../index';

import { CreateTagView } from './style';
export type TagIconVal = {
	id: string;
	url: string;
};

type Props = {
	onClose: (data?: IPOTag.IAddTag) => void;
	upFile: (file: RcFile, FileList: RcFile[]) => Promise<void | TagIconVal>;
	bottomDom?: ReactNode;
	defVal?: IPOTag.IAddTag & { logoInfo?: TagIconVal };
	isDelLogo?: boolean;
	upTips?: string;
} & ModalProps;
export const CreateTag: FC<Props> = ({
	onClose,
	upFile,
	bottomDom,
	defVal,
	isDelLogo,
	upTips,
	...addTagsProps
}) => {
	const [form] = Form.useForm();
	const [logoVal, setLogoVal] = useState<undefined | TagIconVal>(undefined);
	useEffect(() => {
		setForm(defVal);
	}, [defVal]);
	const setForm = (data?: IPOTag.IAddTag & { logoInfo?: TagIconVal }) => {
		form.setFieldsValue({
			name: data?.name || '',
			desc: data?.desc || '',
		});
		setLogoVal(data?.logoInfo);
	};
	const onOk = () => {
		form.validateFields().then(async formData => {
			if (!formData.name) {
				return IPOMessage.error('标签必填');
			}
			if (formData.name.length > 6) {
				return IPOMessage.error('标签名字不可超过6个字');
			}

			if (formData.desc.length > 150) {
				return IPOMessage.error('标签名字不可超过150个字');
			}
			formData.icon = logoVal?.id || '';
			onClose && onClose(formData);
		});
	};
	const upLogo = async (file: RcFile, fileList: RcFile[]) => {
		const logo = await upFile(file, fileList);
		if (logo) {
			setLogoVal(logo);
		}
	};

	return (
		<IPOModal
			maskClosable={false}
			title="添加标签"
			getContainer={false}
			visible={true}
			onOk={onOk}
			onCancel={() => {
				onClose();
			}}
			isShowPadding={true}
			{...addTagsProps}>
			<CreateTagView>
				<Form name="createTag" form={form} layout="vertical">
					<Form.Item
						label={
							<span>
								<span className="tips-red">*</span>标签名称
							</span>
						}
						name="name">
						<IPOInput />
					</Form.Item>
					<Form.Item label="描述" name="desc">
						<Input.TextArea />
					</Form.Item>
					<Form.Item label="">
						<div className="up-title">
							上传标签logo {upTips && <span className="up-tips">({upTips})</span>}
						</div>
						<Upload
							accept=".png,.jpeg,.jpg,.webp"
							showUploadList={false}
							beforeUpload={(file, allFiles) => upLogo(file, allFiles)}>
							<div className="up-icon" alt-tip={JSON.stringify({ tit: '可上传代表此标签的图标/logo', time: 3 })}>
								{!logoVal && <img src={IPOIcons.actions.addBlueIcon} />}
								{logoVal && <img className="logo" src={logoVal.url}></img>}
								{logoVal && isDelLogo && (
									<img
										className="del"
										onClick={e => {
											e.stopPropagation();
											setLogoVal(undefined);
										}}
										src={IPOIcons.actions.delCircleIcon}></img>
								)}
							</div>
						</Upload>
					</Form.Item>
				</Form>
				{bottomDom}
			</CreateTagView>
		</IPOModal>
	);
};
